import React from 'react';
import { TrendingUp, Minus, AlertCircle } from 'lucide-react';

export type DifficultyLevel = 'EASY' | 'MEDIUM' | 'HARD';

interface DifficultyBadgeProps {
  difficulty: DifficultyLevel;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  className?: string;
}

const difficultyConfig: Record<
  DifficultyLevel,
  {
    label: string;
    bgColor: string;
    textColor: string;
    icon: React.ReactNode;
  }
> = {
  EASY: {
    label: 'Easy',
    bgColor: 'bg-emerald-100',
    textColor: 'text-emerald-700',
    icon: <Minus className="w-3 h-3" />,
  },
  MEDIUM: {
    label: 'Medium',
    bgColor: 'bg-amber-100',
    textColor: 'text-amber-700',
    icon: <TrendingUp className="w-3 h-3" />,
  },
  HARD: {
    label: 'Hard',
    bgColor: 'bg-red-100',
    textColor: 'text-red-700',
    icon: <AlertCircle className="w-3 h-3" />,
  },
};

const sizeClasses = {
  sm: 'text-xs px-2 py-0.5 gap-1',
  md: 'text-sm px-2.5 py-1 gap-1.5',
  lg: 'text-base px-3 py-1.5 gap-2',
};

export const DifficultyBadge: React.FC<DifficultyBadgeProps> = ({
  difficulty,
  size = 'md',
  showIcon = true,
  className = '',
}) => {
  const config = difficultyConfig[difficulty];

  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-full
        ${config.bgColor} ${config.textColor} ${sizeClasses[size]}
        ${className}
      `}
    >
      {showIcon && config.icon}
      <span>{config.label}</span>
    </span>
  );
};
